const ID_AUDIENCIA_SOL_COM_CONSUMIDOR_API = 1;
const AUDIENCIA_SOL_COM_CONSUMIDOR_API = {
	id: ID_AUDIENCIA_SOL_COM_CONSUMIDOR_API,
	nome: 'Consumidor de API'
}

const ID_AUDIENCIA_SOL_COM_FORNECEDOR_API = 2;
const AUDIENCIA_SOL_COM_FORNECEDOR_API = {
	id: ID_AUDIENCIA_SOL_COM_FORNECEDOR_API,
	nome: 'Fornecedor de API'
}

const ID_AUDIENCIA_SOL_COM_OPERADOR_API = 3;
const AUDIENCIA_SOL_COM_OPERADOR_API = {
	id: ID_AUDIENCIA_SOL_COM_OPERADOR_API,
	nome: 'Operador de API'
}

const ID_AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV = 4;
const AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV = {
	id: ID_AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV,
	nome: 'Consumidor de Arquivo'
}

const ID_AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV = 5;
const AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV = {
	id: ID_AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV,
	nome: 'Fornecedor de Arquivo'
}

const ID_AUDIENCIA_SOL_COM_PONTOS_FOCAIS = 6;
const AUDIENCIA_SOL_COM_PONTOS_FOCAIS = {
	id: ID_AUDIENCIA_SOL_COM_PONTOS_FOCAIS,
	nome: 'Pontos Focais'
}

export {
	ID_AUDIENCIA_SOL_COM_CONSUMIDOR_API, AUDIENCIA_SOL_COM_CONSUMIDOR_API,
	ID_AUDIENCIA_SOL_COM_FORNECEDOR_API, AUDIENCIA_SOL_COM_FORNECEDOR_API,
	ID_AUDIENCIA_SOL_COM_OPERADOR_API, AUDIENCIA_SOL_COM_OPERADOR_API,
	ID_AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV, AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV,
	ID_AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV, AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV,
	ID_AUDIENCIA_SOL_COM_PONTOS_FOCAIS, AUDIENCIA_SOL_COM_PONTOS_FOCAIS,
 }